<template>
	<div class="ExaminationInfo sw-container">
		<div class="common-nav">
			<span class="s1">您的位置</span>
			<span class="s2">|</span>
			<span class="s1">考试</span>
			<span class="s2">|</span>
			<span class="s3">开始考试</span>
		</div>
		<div class="ExaminationInfo-main">
			<div>
				<div class="ExaminationInfo-main-l" v-if="dataInfo.length > 0">
					<div class="ExaminationInfo-title">考试</div>
					<div class="ExaminationInfo-subject">
						{{ pageIndex }}.{{ dataInfo[pageIndex - 1].title }}({{
              dataInfo[pageIndex - 1].type
            }})
					</div>
					<template v-if="dataInfo[pageIndex - 1].type == '单选'">
						<div class="ExaminationInfo-answer" :class="{ 'ExaminationInfo-answer-active': active == 'a' }"
							@click="handleSelect('单选', 'a')">
							<span>A</span>
							<p>{{ dataInfo[pageIndex - 1].ansa }}</p>
						</div>
						<div class="ExaminationInfo-answer" :class="{ 'ExaminationInfo-answer-active': active == 'b' }"
							@click="handleSelect('单选', 'b')">
							<span>B</span>
							<p>{{ dataInfo[pageIndex - 1].ansb }}</p>
						</div>
						<div class="ExaminationInfo-answer" :class="{ 'ExaminationInfo-answer-active': active == 'c' }"
							@click="handleSelect('单选', 'c')">
							<span>C</span>
							<p>{{ dataInfo[pageIndex - 1].ansc }}</p>
						</div>
						<div class="ExaminationInfo-answer" :class="{ 'ExaminationInfo-answer-active': active == 'd' }"
							@click="handleSelect('单选', 'd')">
							<span>D</span>
							<p>{{ dataInfo[pageIndex - 1].ansd }}</p>
						</div>
					</template>
					<template v-if="dataInfo[pageIndex - 1].type == '多选'">
						<div class="ExaminationInfo-answer" :class="{
                'ExaminationInfo-answer-active': active.indexOf('a') >= 0,
              }" @click="handleSelect('多选', 'a')">
							<span>A</span>
							<p>{{ dataInfo[pageIndex - 1].ansa }}</p>
						</div>
						<div class="ExaminationInfo-answer" :class="{
                'ExaminationInfo-answer-active': active.indexOf('b') >= 0,
              }" @click="handleSelect('多选', 'b')">
							<span>B</span>
							<p>{{ dataInfo[pageIndex - 1].ansb }}</p>
						</div>
						<div class="ExaminationInfo-answer" :class="{
                'ExaminationInfo-answer-active': active.indexOf('c') >= 0,
              }" @click="handleSelect('多选', 'c')">
							<span>C</span>
							<p>{{ dataInfo[pageIndex - 1].ansc }}</p>
						</div>
						<div class="ExaminationInfo-answer" :class="{
                'ExaminationInfo-answer-active': active.indexOf('d') >= 0,
              }" @click="handleSelect('多选', 'd')">
							<span>D</span>
							<p>{{ dataInfo[pageIndex - 1].ansd }}</p>
						</div>
					</template>
					<template v-if="dataInfo[pageIndex - 1].type == '判断'">
						<div class="ExaminationInfo-answer" :class="{ 'ExaminationInfo-answer-active': active == 'a' }"
							@click="handleSelect('判断', 'a')">
							<span>A</span>
							<p>正确</p>
						</div>
						<div class="ExaminationInfo-answer" :class="{ 'ExaminationInfo-answer-active': active == 'b' }"
							@click="handleSelect('判断', 'b')">
							<span>B</span>
							<p>错误</p>
						</div>
					</template>
					<div class="ExaminationInfo-bar">
						<div class="ExaminationInfo-btn ExaminationInfo-btn-activation" v-if="pageIndex != 1"
							@click="handlePrev">
							上一题
						</div>
						<div class="ExaminationInfo-btn ExaminationInfo-btn-activation" v-if="pageIndex != total"
							@click="handleNext">
							下一题
						</div>
						<div class="ExaminationInfo-bar-r">
							<Checkbox v-model="single" @on-change="handleSign">标记</Checkbox>
						</div>
					</div>
				</div>
			</div>
			<div class="ExaminationInfo-main-r">
				<div class="ExaminationInfo-overview" v-if="dataInfo.length > 0">
					<div class="ExaminationInfo-overview-title">
						<p>倒计时</p>
						<time>{{ countdown }}</time>
					</div>
					<div class="ExaminationInfo-overview-main">
						<div class="ExaminationInfo-overview-progress">
							<span>答题进度</span>
							<span>{{ answerJson.length }}/{{ dataInfo.length }}</span>
						</div>
						<div class="ExaminationInfo-overview-item">
							<div class="ExaminationInfo-overview-topic" v-if="dataAll.entities.ss">
								选择题 （{{ dataAll.entities.ss.a }}分/题，共{{
                  dataAll.entities.ss.b
                }}分）
							</div>
							<div class="ExaminationInfo-overview-list">
								<template v-for="(i, index) in dataInfo">
									<div :key="i.index" class="ExaminationInfo-overview-num"
										@click="handleChangeTopic(index)" :class="{
                      'ExaminationInfo-overview-yes': i.ok == 1,
                      'ExaminationInfo-overview-active': i.question == 1,
                    }" v-if="i.type == '单选'">
										{{ index + 1 }}
									</div>
								</template>
							</div>
						</div>
						<div class="ExaminationInfo-overview-item">
							<div class="ExaminationInfo-overview-topic" v-if="dataAll.entities.tf">
								判断题 （{{ dataAll.entities.tf.a }}分/题，共{{
                  dataAll.entities.tf.b
                }}分）
							</div>
							<div class="ExaminationInfo-overview-list">
								<template v-for="(i, index) in dataInfo">
									<div :key="i.index" class="ExaminationInfo-overview-num"
										@click="handleChangeTopic(index)" :class="{
                      'ExaminationInfo-overview-yes': i.ok == 1,
                      'ExaminationInfo-overview-active': i.question == 1,
                    }" v-if="i.type == '判断'">
										{{ index + 1 }}
									</div>
								</template>
							</div>
						</div>
						<div class="ExaminationInfo-overview-item">
							<div class="ExaminationInfo-overview-topic" v-if="dataAll.entities.ms">
								多选题 （{{ dataAll.entities.ms.a }}分/题，共{{
                  dataAll.entities.ms.b
                }}分）
							</div>
							<div class="ExaminationInfo-overview-list">
								<template v-for="(i, index) in dataInfo">
									<div :key="i.index" class="ExaminationInfo-overview-num"
										@click="handleChangeTopic(index)" :class="{
                      'ExaminationInfo-overview-yes': i.ok == 1,
                      'ExaminationInfo-overview-active': i.question == 1,
                    }" v-if="i.type == '多选'">
										{{ index + 1 }}
									</div>
								</template>
							</div>
						</div>
						<div class="ExaminationInfo-overview-bottom">
							<span class="s1"> <span class="s2 s3"></span>已答 </span>
							<span class="s1"> <span class="s2"></span>未答 </span>
							<span class="s1"> <span class="s2 s4"></span>标记 </span>
						</div>
					</div>
				</div>
				<Poptip confirm title="确定提交试卷?" @on-ok="handleSubmit" placement="left-end">
					<div class="ExaminationInfo-overview-btn">提交试卷</div>
				</Poptip>
			</div>
		</div>
		<Spin fix v-if="spinShow">
			<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
			<div>请等待...</div>
		</Spin>
	</div>
</template>

<script>
	import * as api from "@/assets/api/api.js";
	import axios from "axios";
	export default {
		name: "ExaminationInfo",
		components: {},
		data() {
			return {
				search: "",
				single: "",
				single2: "",
				spinShow: false,
				dataAll: {
					entities: {},
				},
				dataInfo: {
					entities: [],
				},
				pageIndex: 1,
				total: "",
				active: "",
				answerJson: [],
				axamId: "",
				countdown: "120:00",
				startTime: "",
				endTime: "",
			};
		},
		created() {
			this.getData();
			let num = 7200;
			this.timer = setInterval(() => {
				num--;
				this.countdown = `${Math.floor(num / 60)}:${
        num % 60 < 10 ? "0" + (num % 60) : num % 60
      }`;
				if (num == 0) {
					//没有完成验证
					clearInterval(this.timer);
				}
			}, 1000);
			api.EventBus.$emit("changeNav", 2);
		},
		mounted() {
			// this._interval = setInterval(() => {
			// 	let url = window.location.protocol+"//"+window.location.host;
			// 	console.log(url)
			// 	axios.post(url);
			// }, 3000)
		},
		beforeDestroy() {
			clearInterval(this._interval)
		},
		computed: {},
		methods: {
			getData() {
				api.showLoading();
				// console.log(this.$route.query.id)
				var params = {
					id: this.$route.query.id,
				};
				api.postDataJxjy("/jxjyapi/Tenpoint/generatedData", params).then(res => {
					// console.log(res);
					if (res.code == 1) {
						api
							.postDataJAVA("/exam/questListPage", {
								cuid: this.$route.query.id,
								format: "v2",
							})
							.then((res) => {
								// console.log(res);
								var arr = [];
								if (res.data.entities["ss"]) {
									arr = arr.concat(res.data.entities["ss"].list);
								}
								if (res.data.entities["tf"]) {
									arr = arr.concat(res.data.entities["tf"].list);
								}
								if (res.data.entities["ms"]) {
									arr = arr.concat(res.data.entities["ms"].list);
								}
								this.dataInfo = arr;
								this.total = arr.length;
								this.dataAll = res.data;
								// console.log(this.dataInfo);
								if (this.dataInfo[this.pageIndex - 1].type == "多选") {
									this.active = [];
								} else {
									this.active = "";
								}
							}).catch(function(error) {
								// console.log('error：' + error);
							});
					}
				}).catch(function(error) {
					// console.log('error：' + error);
				});
				// return

			},
			handlePrev() {
				//   let oData;
				//   //判断是否答题过
				//   let btn = false;
				//   let btnIndex = null;
				//   for (let i of this.answerJson) {
				//     if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
				//       btn = true;
				//       btnIndex = this.answerJson.indexOf(i);
				//     }
				//   }
				//   if (btn) {
				//     this.answerJson.splice(btnIndex, 1);
				//   }
				//   //做出了选择
				//   if (this.active.length > 0) {
				//     if (this.dataInfo[this.pageIndex - 1].type == "单选") {
				//       oData = {
				//         spid: this.dataInfo[this.pageIndex - 1].id,
				//         answer: this.active,
				//         type: "单选",
				//       };
				//     }
				//     if (this.dataInfo[this.pageIndex - 1].type == "多选") {
				//       oData = {
				//         spid: this.dataInfo[this.pageIndex - 1].id,
				//         answer: this.active.join(","),
				//         type: "多选",
				//       };
				//     }
				//     if (this.dataInfo[this.pageIndex - 1].type == "判断") {
				//       oData = {
				//         spid: this.dataInfo[this.pageIndex - 1].id,
				//         answer: this.active == "a" ? "正确" : "错误",
				//         type: "判断",
				//       };
				//     }
				//     this.answerJson.push(oData);
				//     this.dataInfo[this.pageIndex - 1].ok = 1;
				//   }
				this.pageIndex--;
				let isSelected = false; //判断是否答题过
				if (this.dataInfo[this.pageIndex - 1].question == 1) {
					this.single = true;
				} else {
					this.single = false;
				}
				for (let i of this.answerJson) {
					if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
						isSelected = true;
					}
				}
				if (!isSelected) {
					if (this.dataInfo[this.pageIndex - 1].type == "多选") {
						this.active = [];
					} else {
						this.active = "";
					}
				} else {
					for (let i of this.answerJson) {
						if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
							if (i.type == "多选") {
								this.active = i.answer.split(",");
							} else {
								this.active = i.answer;
							}
						}
					}
				}
			},
			handleNext() {
				//   let oData;
				//   //判断是否答题过
				//   let btn = false;
				//   let btnIndex = null;
				//   for (let i of this.answerJson) {
				//     if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
				//       btn = true;
				//       btnIndex = this.answerJson.indexOf(i);
				//     }
				//   }
				//   if (btn) {
				//     this.answerJson.splice(btnIndex, 1);
				//   }
				//   //做出了选择
				//   if (this.active.length > 0) {
				//     if (this.dataInfo[this.pageIndex - 1].type == "单选") {
				//       oData = {
				//         spid: this.dataInfo[this.pageIndex - 1].id,
				//         answer: this.active,
				//         type: "单选",
				//       };
				//     }
				//     if (this.dataInfo[this.pageIndex - 1].type == "多选") {
				//       oData = {
				//         spid: this.dataInfo[this.pageIndex - 1].id,
				//         answer: this.active.join(","),
				//         type: "多选",
				//       };
				//     }
				//     if (this.dataInfo[this.pageIndex - 1].type == "判断") {
				//       oData = {
				//         spid: this.dataInfo[this.pageIndex - 1].id,
				//         answer: this.active == "a" ? "正确" : "错误",
				//         type: "判断",
				//       };
				//     }
				//     this.answerJson.push(oData);
				//     this.dataInfo[this.pageIndex - 1].ok = 1;
				//   }

				this.pageIndex++;
				let isSelected = false; //判断是否答题过
				if (this.dataInfo[this.pageIndex - 1].question == 1) {
					this.single = true;
				} else {
					this.single = false;
				}
				for (let i of this.answerJson) {
					if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
						isSelected = true;
					}
				}
				if (!isSelected) {
					if (this.dataInfo[this.pageIndex - 1].type == "多选") {
						this.active = [];
					} else {
						this.active = "";
					}
				} else {
					for (let i of this.answerJson) {
						if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
							if (i.type == "多选") {
								this.active = i.answer.split(",");
							} else {
								this.active = i.answer;
							}
						}
					}
				}
			},
			handleChangeTopic(i) {
				//   //判断是否答题过
				//   let btn = false;
				//   let btnIndex = null;
				//   if (this.pageIndex == this.total) {
				//     let oData;
				//     for (let i of this.answerJson) {
				//       if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
				//         btn = true;
				//         btnIndex = this.answerJson.indexOf(i);
				//       }
				//     }
				//     if (btn) {
				//       this.answerJson.splice(btnIndex, 1);
				//     }
				//     //做出了选择
				//     if (this.active.length > 0) {
				//       if (this.dataInfo[this.pageIndex - 1].type == "单选") {
				//         oData = {
				//           spid: this.dataInfo[this.pageIndex - 1].id,
				//           answer: this.active,
				//           type: "单选",
				//         };
				//       }
				//       if (this.dataInfo[this.pageIndex - 1].type == "多选") {
				//         oData = {
				//           spid: this.dataInfo[this.pageIndex - 1].id,
				//           answer: this.active.join(","),
				//           type: "多选",
				//         };
				//       }
				//       if (this.dataInfo[this.pageIndex - 1].type == "判断") {
				//         oData = {
				//           spid: this.dataInfo[this.pageIndex - 1].id,
				//           answer: this.active == "a" ? "正确" : "错误",
				//           type: "判断",
				//         };
				//       }
				//       this.answerJson.push(oData);
				//       this.dataInfo[this.pageIndex - 1].ok = 1;
				//     }
				//   }
				//判断是否答题过
				let isSelected = false; //判断是否答题过
				this.pageIndex = i + 1;
				if (this.dataInfo[this.pageIndex - 1].question == 1) {
					this.single = true;
				} else {
					this.single = false;
				}
				for (let i of this.answerJson) {
					if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
						isSelected = true;
					}
				}
				if (!isSelected) {
					if (this.dataInfo[this.pageIndex - 1].type == "多选") {
						this.active = [];
					} else {
						this.active = "";
					}
				} else {
					for (let i of this.answerJson) {
						if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
							if (i.type == "多选") {
								this.active = i.answer.split(",");
							} else {
								this.active = i.answer;
							}
						}
					}
				}
			},
			handleSelect(type, answer) {
				let selectedData; //存储选中的答案数据
				let isSelected = false; //判断是否答题过
				let selectedIndex = null; //选中数据对应的下标
				for (let i of this.answerJson) {
					if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
						isSelected = true;
						selectedIndex = this.answerJson.indexOf(i);
					}
				}
				if (isSelected) {
					//答过题将当前题数据删除  在加上当前选中数据(会存在重新选答案情况,所以直接删除后在加上)
					this.answerJson.splice(selectedIndex, 1);
				}
				if (type == "单选") {
					this.active = answer;
				} else if (type == "多选") {
					if (this.active.indexOf(answer) >= 0) {
						this.active.splice(this.active.indexOf(answer), 1);
					} else {
						this.active.push(answer);
					}
				} else if (type == "判断") {
					this.active = answer;
				}
				if (this.dataInfo[this.pageIndex - 1].type == "单选") {
					selectedData = {
						spid: this.dataInfo[this.pageIndex - 1].id,
						answer: this.active,
						type: "单选",
					};
				}
				if (this.dataInfo[this.pageIndex - 1].type == "多选") {
					selectedData = {
						spid: this.dataInfo[this.pageIndex - 1].id,
						answer: this.active.join(","),
						type: "多选",
					};
				}
				if (this.dataInfo[this.pageIndex - 1].type == "判断") {
					selectedData = {
						spid: this.dataInfo[this.pageIndex - 1].id,
						answer: this.active,
						//   answer: this.active == "a" ? "正确" : "错误",
						type: "判断",
					};
				}
				this.answerJson.push(selectedData);
				this.dataInfo[this.pageIndex - 1].ok = 1;
			},
			handleSign(e) {
				if (e) {
					this.dataInfo[this.pageIndex - 1].question = 1;
				} else {
					this.dataInfo[this.pageIndex - 1].question = 0;
				}
			},
			handleSubmit() {
				//   if (this.pageIndex == this.total) {
				//     let oData;
				//     //判断是否答题过
				//     let btn = false;
				//     let btnIndex = null;
				//     for (let i of this.answerJson) {
				//       if (i.spid == this.dataInfo[this.pageIndex - 1].id) {
				//         btn = true;
				//         btnIndex = this.answerJson.indexOf(i);
				//       }
				//     }
				//     if (btn) {
				//       this.answerJson.splice(btnIndex, 1);
				//     }
				//     //做出了选择
				//     if (this.active.length > 0) {
				//       if (this.dataInfo[this.pageIndex - 1].type == "单选") {
				//         oData = {
				//           spid: this.dataInfo[this.pageIndex - 1].id,
				//           answer: this.active,
				//           type: "单选",
				//         };
				//       }
				//       if (this.dataInfo[this.pageIndex - 1].type == "多选") {
				//         oData = {
				//           spid: this.dataInfo[this.pageIndex - 1].id,
				//           answer: this.active.join(","),
				//           type: "多选",
				//         };
				//       }
				//       if (this.dataInfo[this.pageIndex - 1].type == "判断") {
				//         oData = {
				//           spid: this.dataInfo[this.pageIndex - 1].id,
				//           answer: this.active == "a" ? "正确" : "错误",
				//           type: "判断",
				//         };
				//       }
				//       this.answerJson.push(oData);
				//       this.dataInfo[this.pageIndex - 1].ok = 1;
				//     }
				//   }
				var duration =
					7200 -
					(this.countdown.split(":")[0] * 60 + this.countdown.split(":")[1] * 1);
				this.spinShow = true;
				api
					.postData("exam/saveRecord", {
						comboId: this.$route.query.id,
						orderId: this.$route.query.orderId,
						aptitudename: "v2",
					})
					.then((res) => {
						this.axamId = res.data.id;
						api
							.postData("exam/submitPaper", {
								duration,
								axamId: this.axamId,
								answerJson: JSON.stringify(this.answerJson),
							})
							.then((res) => {
								this.spinShow = false;
								sessionStorage.setItem(
									"ExaminationResult",
									JSON.stringify(res.data)
								);
								this.$router.push({
									path: "/ExaminationResult",
									query: {
										id: this.$route.query.id,

									},
								});
							});
					});
			},
		},
		watch: {},
	};
	//	entities:{
	//		'单选':{
	//			list:[{题目}],
	//			a:'一题多少分',
	//			b:'共多少分'
	//		},
	//		'多选':{
	//			list:[{题目}],
	//			a:'一题多少分',
	//			b:'共多少分'
	//		},
	//		'判断':{
	//			list:[{题目}],
	//			a:'一题多少分',
	//			b:'共多少分'
	//		}
	//	}
</script>

<style lang="scss">
	.ExaminationInfo {
		padding-bottom: 30px;

		&-overview {
			background: #fff;

			&-btn {
				width: 280px;
				height: 40px;
				background: rgba(236, 105, 65, 1);
				border-radius: 4px;
				line-height: 40px;
				text-align: center;
				cursor: pointer;
				color: #ffffff;
				font-size: 14px;
				margin-top: 16px;
			}

			&-btn:hover {
				background: rgba(236, 105, 65, 0.8);
			}

			&-bottom {
				display: flex;

				.s1 {
					margin-right: 32px;
					display: flex;
					align-items: center;
				}

				.s1:last-child {
					margin-right: 0;
				}

				.s2 {
					width: 16px;
					height: 16px;
					background: rgba(255, 255, 255, 1);
					border: 1px solid rgba(153, 153, 153, 1);
					border-radius: 50%;
					display: inline-block;
					margin-right: 8px;
				}

				.s3 {
					background: #cccccc;
					border-color: #cccccc;
				}

				.s4 {
					background: #37bc5f;
					border-color: #37bc5f;
				}
			}

			&-list {
				display: flex;
				flex-wrap: wrap;
			}

			&-num {
				width: 36px;
				height: 36px;
				background: rgba(255, 255, 255, 1);
				border: 1px solid rgba(153, 153, 153, 1);
				border-radius: 50%;
				text-align: center;
				line-height: 36px;
				color: #161a21;
				font-size: 16px;
				margin-right: 15px;
				margin-bottom: 15px;
				cursor: pointer;
			}

			&-yes {
				background: #cccccc;
				border-color: #cccccc;
				color: #fff;
			}

			&-active {
				background: #37bc5f;
				border-color: #37bc5f;
				color: #fff;
			}

			&-num:nth-of-type(5n) {
				margin-right: 0;
			}

			&-title {
				padding: 14px 14px 20px;
				border-bottom: 1px solid #f0f1f4;
				margin-bottom: 26px;

				p {
					color: #222222;
					font-size: 16px;
				}

				time {
					color: #ec6941;
					font-size: 36px;
					font-weight: bold;
					display: block;
					text-align: center;
				}
			}

			&-main {
				padding: 15px;
			}

			&-progress {
				font-size: 16px;
				color: #222222;
				font-weight: bold;
				margin-bottom: 26px;

				span {
					margin-right: 10px;
				}
			}

			&-topic {
				color: #666666;
				font-size: 14px;
				margin-bottom: 8px;
			}
		}

		&-main {
			display: flex;
			justify-content: space-between;
			min-height: 505px;

			&-l {
				background: #fbfbfb;
				padding-top: 20px;
				width: 900px;
				padding-bottom: 65px;
			}

			&-r {
				width: 280px;
			}
		}

		&-title {
			line-height: 1;
			font-size: 16px;
			border-left: 2px solid #31af58;
			padding-left: 10px;
			margin-left: 20px;
			margin-bottom: 42px;
		}

		&-subject {
			font-size: 16px;
			color: #161a21;
			margin-left: 60px;
			margin-bottom: 50px;
		}

		&-answer {
			margin-left: 80px;
			display: flex;
			margin-bottom: 16px;
			align-items: center;
			cursor: pointer;

			span {
				width: 30px;
				height: 30px;
				border: 1px solid #161a21;
				line-height: 30px;
				text-align: center;
				border-radius: 50%;
				margin-right: 20px;
			}

			&-active {
				span {
					background: #ec6941;
					border-color: #ec6941;
					color: #fff;
				}
			}

			p {
				color: #161a21;
				font-size: 16px;
				flex: 1;
			}
		}

		&-bar {
			margin-left: 60px;
			margin-top: 80px;
			display: flex;
			align-items: flex-end;

			&-r {
				flex: 1;
				text-align: right;
				padding-right: 70px;

				.ivu-checkbox-wrapper {
					display: block;
					margin-bottom: 20px;
				}

				.ivu-checkbox-wrapper:last-child {
					margin-bottom: 0;
				}

				.ivu-checkbox {
					margin-right: 8px;
				}

				.ivu-checkbox-inner {
					width: 20px;
					height: 20px;
					border-radius: 50%;
					border-color: #222222;
				}

				.ivu-checkbox-checked .ivu-checkbox-inner {
					border: none;
					background: none;
				}

				.ivu-checkbox-checked .ivu-checkbox-inner:after {
					content: "";
					width: 20px;
					height: 20px;
					border: none;
					background: url(../../assets/img/kicn2.png) no-repeat;
					background-size: 100%;
					transform: rotate(0) scale(1);
					top: 0;
					left: 0;
				}
			}
		}

		&-btn {
			width: 120px;
			height: 40px;
			border: 1px solid rgba(153, 153, 153, 1);
			border-radius: 4px;
			text-align: center;
			line-height: 40px;
			color: #999999;
			font-size: 14px;
			margin-right: 20px;

			&-activation {
				cursor: pointer;
				color: #161a21;
				border-color: #161a21;
			}

			&-activation:hover {
				color: #37bc5f;
				border-color: #37bc5f;
			}
		}
	}
</style>